class Product {
  /**
   * handle count of cart in products
   * @param {Array} cart
   * @param {Array} products
   * @return new array
   */
  countCartInProduct(cart = [], products = []) {
    const _products = products.map(product => {
      let has = false;

      for(var j = 0; j < cart.length; j++) {
        if(product.id === cart[j].product.id) {
          has = true;

          return {
            ...product,
            count: {
              quantity: cart[j].product.quantity
            }
          }
        }
      }

      if(!has) {
        return {
          ...product,
          count: {
            quantity: 0
          }
        }
      }

      // this return for warning js and react
      // not have any work, just return null
      return null

    })

    return _products
  }

  cartItemId(cart = [], productId) {
    let data = null

    for(const c of cart) {
      if(c.product.id === productId) {
        data = c.id
        break
      }
    }

    return data
  }

  hasItemInCart(cart = [], productId) {
    return this.cartItemId(cart, productId) != null
  }
}

export default new Product();
